import { SquooshedPictureKey } from 'components/picture/pictures'
import { Caption, Title, Title_h4_default } from 'components/Typography'
import { SPicture, SStack, SWizardHeroGrid } from './WizardHero.styled'
import { FC, ReactNode } from 'react'

export type WizardHeroProps = {
  caption: string
  title: ReactNode
  pictureKey: SquooshedPictureKey
}

export const WizardHero: FC<React.PropsWithChildren<WizardHeroProps>> = (props) => {
  const { caption, title, children } = props

  return (
    <SWizardHeroGrid>
      <SStack space={'1rem'}>
        <Caption>{caption}</Caption>
        <Title variant={Title_h4_default}>{title}</Title>
        <div>{children}</div>
      </SStack>
      <SPicture imageKey={props.pictureKey} />
    </SWizardHeroGrid>
  )
}
